/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Delete_EdgeInputs */

const cs_workflow_delete_edge = /** @type {(inputs: Workflow_Delete_EdgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikněte pro odstranění spojení`)
};

const en_workflow_delete_edge = /** @type {(inputs: Workflow_Delete_EdgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to remove this connection`)
};

/**
* | output |
* | --- |
* | "Click to remove this connection" |
*
* @param {Workflow_Delete_EdgeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_delete_edge = /** @type {((inputs?: Workflow_Delete_EdgeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Delete_EdgeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_delete_edge(inputs)
	return cs_workflow_delete_edge(inputs)
});